import { make_listicle } from "../reviews/listicle_template";

let review = make_listicle("ai_coins",8,false);

export default review;